module.exports = __webpack_public_path__ + "img/papyrus_tweed.f1f3296e.jpeg";